import { render, staticRenderFns } from "./MainTopBar.vue?vue&type=template&id=48441f56&"
import script from "./MainTopBar.vue?vue&type=script&lang=js&"
export * from "./MainTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports